/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize AlbuminuriaF13 View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AlbuminuriaF13View';

export const mapStateToPropsAlbuminuriaF13 = mapStateToProps;
export const mapDispatchToPropsAlbuminuriaF13 = mapDispatchToProps;

export default connect(
  mapStateToPropsAlbuminuriaF13,
  mapDispatchToPropsAlbuminuriaF13
)(View);
